/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedsecondreminderleadtime4Inputs */

const en__field_inheritedsecondreminderleadtime4 = /** @type {(inputs: _Field_Inheritedsecondreminderleadtime4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Second Reminder x Days ahead (inherited)`)
};

const de__field_inheritedsecondreminderleadtime4 = /** @type {(inputs: _Field_Inheritedsecondreminderleadtime4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweite Erinnerung x Tage vorher (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "Second Reminder x Days ahead (inherited)" |
*
* @param {_Field_Inheritedsecondreminderleadtime4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedsecondreminderleadtime4 = /** @type {((inputs?: _Field_Inheritedsecondreminderleadtime4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedsecondreminderleadtime4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedsecondreminderleadtime4(inputs)
	return de__field_inheritedsecondreminderleadtime4(inputs)
});
export { _field_inheritedsecondreminderleadtime4 as "_field_inheritedSecondReminderLeadTime" }